import { BaseHttpRequest } from '@core/models';

export class HttpHeader {
  private _name: string;

  protected value: string;

  protected readFn?: () => string;

  protected writeFn?: (value: string) => void;

  protected addAllowedFn?: (req: BaseHttpRequest) => boolean;

  get name(): string {
    return this._name;
  }

  constructor(
    /**
     * nome header
     */
    name: string,
    options: {
      /**
       * funzione per leggere il valore salvato su sistema di storage
       */
      readFn?: () => string;
      /**
       * funzione per salvare il valore su sistema di storage
       */
      writeFn?: (value: string) => void;
      /**
       * funzione per stabilire se l'aggiunta dell'header sulla richiesta è abilitata
       */
      addAllowedFn?: (req: BaseHttpRequest) => boolean;
    }
  ) {
    this._name = name;

    if (typeof options.readFn === 'function') {
      this.readFn = options.readFn;
    }

    if (typeof options.writeFn === 'function') {
      this.writeFn = options.writeFn;
    }

    if (typeof options.addAllowedFn === 'function') {
      this.addAllowedFn = options.addAllowedFn;
    }
  }

  /**
   * restituisce il valore;
   * se non valorizzato in cache, prova a recuperarlo tramite funzione impostata
   */
  getValue(): string {
    if (!!this.value) {
      return this.value;
    }

    if (typeof this.readFn === 'function') {
      this.value = this.readFn();
    }

    return this.value;
  }

  /**
   * salva il nuovo valore in cache;
   * se è impostata una funziona di scrittura, la invoca
   */
  setValue(value: string): void {
    this.value = value;

    if (typeof this.writeFn === 'function') {
      this.writeFn(value);
    }
  }

  /**
   * stabilisce se la richiesta è abilitata
   */
  isAddAllowed(req: BaseHttpRequest): boolean {
    return typeof this.addAllowedFn !== 'function' || this.addAllowedFn(req);
  }
}
